export default "__VITE_ASSET__CyndKbhF__"